import React, { useContext } from "react"
import { formatBaseMolecules, formatFocusedImage } from "../formatBaseMolecules"
import formatCards from "../formatCards"
import formatAnchor from "../formatAnchor"
import renderPaddingOrFullBleed from "../renderPaddingOrFullBleed"
import { Link } from "gatsby"
import { Carousel } from "terra-one"
import { Element } from "react-scroll"
import formatBioBlocks from "../formatBioBlocks"
import { LayoutContext } from "../../../components/Layout/Layout"
import { formatPullQuote } from "../FormatPullQuote"

const FormatAndRenderCarousel = props => {
  const {
    data = {},
    index,
    locale,
    location,
    appData,
    region,
    currentSpaceId,
    products,
    siteIdentifier,
  } = props

  const { homepageSlug } = useContext(LayoutContext)
  const { anchor, motion } = formatBaseMolecules(data, locale, homepageSlug)

  let contentType = null
  let content = null

  const formatThemeName = theme => {
    return theme?.toLowerCase().replace(" ", "-")
  }

  const theme = data?.theme ? formatThemeName(data?.theme) : "white"

  const formatPullQuotes = quotes => {
    if (quotes && Array.isArray(quotes))
      return quotes?.map(quoteItem =>
        formatPullQuote(
          quoteItem,
          data,
          locale,
          props,
          products,
          siteIdentifier
        )
      )
  }

  if (data?.variant && data?.carouselItems && data?.carouselItems?.length > 0) {
    switch (data.variant) {
      case "Pull Quotes":
        contentType = "pull_quotes"
        content = { quotes: formatPullQuotes(data?.carouselItems) }
        break

      case "Bounded Cards":
        contentType = "bounded_cards"

        const cards = data?.carouselItems
          ? formatCards(
              data?.carouselItems,
              locale,
              location,
              appData,
              region,
              null,
              homepageSlug,
              currentSpaceId,
              products,
              siteIdentifier
            )
          : []
        const filteredCards = cards?.filter(card => {
          return card !== undefined
        })
        content = {
          cards: filteredCards?.length ? filteredCards : null,
          cardAlignment: props?.productPage
            ? false
            : data?.cardAlignment
            ? data?.cardAlignment
            : null,
          displayButton: data?.linkType ? data?.linkType : null,
          Link,
        }

        break

      case "Unbounded Cards":
        contentType = "unbounded_cards"
        const unboundedRatio = { width: 3, height: 2 }
        const unboundedCards = data?.carouselItems
          ? formatCards(
              data?.carouselItems,
              locale,
              location,
              appData,
              region,
              unboundedRatio,
              homepageSlug,
              currentSpaceId,
              products,
              siteIdentifier
            )
          : []
        const filteredUnboundedCards = unboundedCards?.filter(card => {
          return card !== undefined
        })
        content = {
          cards: filteredUnboundedCards?.length ? filteredUnboundedCards : null,
          cardAlignment: props?.productPage
            ? false
            : data?.cardAlignment
            ? data?.cardAlignment
            : null,
          displayButton: data?.linkType ? data?.linkType : null,
          Link,
        }

        break

      case "Bio Blocks":
        contentType = "bio_blocks"
        content = {
          Link,
          cards: data?.carouselItems
            ? formatBioBlocks(
                data?.carouselItems,
                locale,
                currentSpaceId,
                products,
                siteIdentifier
              )
            : null,
        }
        break

      case "Focal Point Images":
        contentType = "focal_point_images"
        content = {
          images: data?.carouselItems?.map(image => formatFocusedImage(image)),
        }
        break

      default:
        break
    }
  }

  if (typeof anchor === "string") {
    return (
      <Element key={`scroll-${index}`} name={formatAnchor(anchor)}>
        <div className={`ter-carousel-wrapper--${theme}`}>
          {renderPaddingOrFullBleed(
            <Carousel
              content={content}
              key={index}
              motion={motion}
              theme={theme}
              type={contentType}
              contentfulId={data?.contentfulId}
              componentClass={`carousel-component`}
            />
          )}
        </div>
      </Element>
    )
  } else {
    return (
      <div className={`ter-carousel-wrapper--${theme}`}>
        {renderPaddingOrFullBleed(
          <Carousel
            type={contentType}
            content={content}
            key={index}
            motion={motion}
            theme={theme}
            contentfulId={data?.contentfulId}
            componentClass={`carousel-component`}
          />
        )}
      </div>
    )
  }
}

export default FormatAndRenderCarousel
